module.exports = __webpack_public_path__ + "static/media/AILogo.2e88ce7c.svg";